import { z } from 'zod';

/**
 * Form values do Step 1 (Dados do Seguro) — Capital Global / categoria OTHER.
 * Validação em tempo real continua nos `validators` do TanStack Form; o Zod
 * centraliza o shape e os defaults para tipagem e evolução futura (ex.: submit unificado).
 */
/**
 * Endereço de um subestipulante. A lista tem tamanho FIXO dentro do Step 1 (os subs são
 * adicionados/removidos na Cotação), então o form nunca precisa de `mode='array'` —
 * basta `setFieldValue('subStipulatorAddresses', rows)` no prefill e um `AppField` por
 * índice.
 */
export const capitalGlobalProposalSubStipulatorAddressSchema = z.object({
  /** `@pk` da linha no InsureMO — casamento preferencial no back. */
  customerPk: z.number().optional(),
  documentNumber: z.string(),
  sequenceNumber: z.number().optional(),
  /** Razão social — só exibição (cabeçalho do bloco). */
  name: z.string(),
  /** Pessoa jurídica (CNPJ) → habilita o preenchimento automático pela consulta de CNPJ. */
  isCompany: z.boolean(),
  cep: z.string(),
  street: z.string(),
  number: z.string(),
  complement: z.string(),
  neighborhood: z.string(),
  city: z.string(),
  state: z.string(),
  phone: z.string(),
  email: z.string(),
  /** CAEPF (pessoa física): sexo e data de nascimento do titular do subestipulante. */
  gender: z.string(),
  dateOfBirth: z.string(),
});

export type CapitalGlobalProposalSubStipulatorAddressValues = z.infer<
  typeof capitalGlobalProposalSubStipulatorAddressSchema
>;

export const capitalGlobalProposalStepDadosDoSeguroSchema = z.object({
  effectiveStartDate: z.string(),
  cnpj: z.string(),
  companyName: z.string(),
  /** CAEPF (pessoa física): data de nascimento e sexo do titular — exigidos pelo i4Pro. */
  dateOfBirth: z.string(),
  gender: z.string(),
  registrationCep: z.string(),
  registrationStreet: z.string(),
  registrationNumber: z.string(),
  registrationComplement: z.string(),
  registrationNeighborhood: z.string(),
  registrationCity: z.string(),
  registrationState: z.string(),
  sameCorrespondenceAsRegistration: z.boolean(),
  correspondenceCep: z.string(),
  correspondenceStreet: z.string(),
  correspondenceNumber: z.string(),
  correspondenceComplement: z.string(),
  correspondenceNeighborhood: z.string(),
  correspondenceCity: z.string(),
  correspondenceState: z.string(),
  subStipulatorAddresses: z.array(capitalGlobalProposalSubStipulatorAddressSchema),
  stipulatorPhone: z.string(),
  stipulatorEmail: z.string(),
  privacyAccepted: z.boolean(),
  customerPk: z.number(),
});

export type CapitalGlobalProposalStepDadosDoSeguroValues = z.infer<
  typeof capitalGlobalProposalStepDadosDoSeguroSchema
>;

export const capitalGlobalProposalStepDadosDoSeguroDefaultValues: CapitalGlobalProposalStepDadosDoSeguroValues =
  {
    effectiveStartDate: '',
    cnpj: '',
    companyName: '',
    dateOfBirth: '',
    gender: '',
    registrationCep: '',
    registrationStreet: '',
    registrationNumber: '',
    registrationComplement: '',
    registrationNeighborhood: '',
    registrationCity: '',
    registrationState: '',
    sameCorrespondenceAsRegistration: true,
    correspondenceCep: '',
    correspondenceStreet: '',
    correspondenceNumber: '',
    correspondenceComplement: '',
    correspondenceNeighborhood: '',
    correspondenceCity: '',
    correspondenceState: '',
    subStipulatorAddresses: [],
    stipulatorPhone: '',
    stipulatorEmail: '',
    privacyAccepted: false,
    customerPk: 0,
  };
